/**
 * ChatMessageData 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'
import type { BattleData } from './battle_data'
import type { CampData } from './camp_data'
import type { ChatMessage } from './chat_message'
import type { UserData } from './user_data'

/**
 * ChatMessageData
 */
export interface ChatMessageData {
  /** 消息ID */
  id?: string
  /** 消息基础信息 */
  info?: ChatMessage
  /** 发送者信息 */
  sender?: UserData
  /** 接收者信息（私信场景） */
  receiver?: UserData
  /** 大本营信息 */
  camp?: CampData
  /** 对线群信息 */
  battle?: BattleData
}

/**
 * ChatMessageData Schema
 */
export const ChatMessageDataSchema: SchemaDefinition = {
  properties: {
    id: {
      description: '消息ID',
      format: 'string',
      type: 'string',
      label: '消息ID',
    },
    info: {
      $ref: 'ChatMessage',
      description: '消息基础信息',
      label: '消息基础信息',
    },
    sender: {
      $ref: 'UserData',
      description: '发送者信息',
      label: '发送者信息',
    },
    receiver: {
      $ref: 'UserData',
      description: '接收者信息（私信场景）',
      label: '接收者信息',
    },
    camp: {
      $ref: 'CampData',
      description: '大本营信息',
      label: '大本营信息',
    },
    battle: {
      $ref: 'BattleData',
      description: '对线群信息',
      label: '对线群信息',
    },
  },
  type: 'object',
}
